<template>
    <div class="weeklyTarget-wrapper">
        <div class="d-flex justify-content-center align-items-center weeklyTarget-header text-center">
            <span class="backArrowIcon" id="close" @click="goBack('someStatus')">
                <img :src='downArrow' alt="Back Arrow" />
            </span>
            <h2 class="m-0">Rules & Regulations</h2>
        </div>
        <div class="weeklyTarget-contentBox">
            <ul class="nav nav-tabs d-flex justify-content-center m-0 border-0" role="tablist">
                <li class="nav-item">
                    <div class="border-0 p-0 mx-4 bg-transparent nav-link" :class="{ 'active': activeTab === 'language1Tab' }"
                        @click="activateTab('language1Tab')" data-toggle="tab" href="#language1Tab" role="tab">Hinglish</div>
                </li>
                <li class="nav-item">
                    <div class="border-0 p-0 mx-4 bg-transparent nav-link" :class="{ 'active': activeTab === 'language2Tab' }" @click="activateTab('language2Tab')"
                        data-toggle="tab" href="#language2Tab" role="tab">English</div>
                </li>
            </ul>
            <div class="tab-content">
                <div class="tab-pane" :class="{ 'active': activeTab === 'language1Tab' }" id="language1Tab" role="tabpanel">
                    <div class="tab-contentIn pt-4">
                        <div class="weeklyTarget-content">
                            <h4 class="mb-3">General Streaming:</h4>
                            <ul>
                                <li>Streaming 24/7 available hai.</li>
                                <li>Hosts ko roz maximum 5 hrs stream aur calls milakar count hoga.</li>
                                <li>Rewards ke liye, har week (Monday se Sunday) total 18 hrs ka live streaming karna zaroori hai.</li>
                                <!-- <li v-if="!hidePeakHourBoxAfterTargetTime">Har Monday ko <b>100,000 coins</b> ka weekly reward milega.</li>
                                <li v-if="!hidePeakHourBoxAfterTargetTime">Rewards ke liye, ek week me minimum <b>100,000 beans</b> earn karna hoga.</li> -->
                            </ul>
                            <!-- <div v-if="!hidePeakHourBoxAfterTargetTime">
                                <h4 class="mt-4 mb-3">Peak Hour Bonus:</h4>
                                <ul>
                                    <li>Valid streaming hours: <b>Raat 9 baje se subah 2 baje tak.</b></li>
                                    <li>Is samay ke dauraan roz maximum 3 hrs stream aur calls milakar count hoga.</li>
                                    <li>Rewards ke liye, har week (Monday se Sunday) total 10 hrs ka live streaming karna zaroori hai.</li>
                                    <li>Har Monday ko <b>50,000 coins</b> ka weekly reward milega.</li>
                                </ul>
                            </div> -->
                            <div>
                                <h4 class="mt-4 mb-3">Earn According to Target</h4>    
                                <div class="weekltTarget-ruleTableWrap afterTargetBox">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Target</th>
                                                <th>Reward</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>100K</td>
                                                <td>40K</td>
                                            </tr>
                                            <tr>
                                                <td>250K</td>
                                                <td>75K</td>
                                            </tr>
                                            <tr>
                                                <td>500K</td>
                                                <td>125K</td>
                                            </tr>
                                            <tr>
                                                <td>1M</td>
                                                <td>250K</td>
                                            </tr>
                                            <tr>
                                                <td>2.5M</td>
                                                <td>625K</td>
                                            </tr>
                                            <tr>
                                                <td>5M</td>
                                                <td>1.25M</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h4 class="mt-4 mb-3">Note :</h4>
                            <ul>
                                <li>For targets <b>up to 500K</b>, Call Earnings + Gifts + Game Tips — <b>all count</b> towards your reward.</li>
                                <li>For <b>1M and above</b>, only <b>Gifts & Game</b> Tips will be counted</li>
                            </ul>
                            <h4 class="mt-4 mb-3">Livestreaming Guidelines</h4>
                            <ul>
                                <li>Apka background saaf-suthra aur organized hona chahiye. Professional look ke liye ek solid ya visually appealing background color use karein.</li>
                                <li>Clear audio ke liye Bluetooth devices ka use karein aur visual effects ko enhance karne ke liye ring light lagayen.</li>
                                <li>Smart casuals pehniye taaki aapki appearance polished aur professional lage.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'language2Tab' }" id="language2Tab" role="tabpanel">
                    <div class="tab-contentIn pt-4">
                        <div class="weeklyTarget-content">
                            <h4 class="mb-3">General Streaming:</h4>
                            <ul>
                                <li>Streaming is available 24/7.</li>
                                <li>Hosts must stream and engage in calls for a maximum of 5 hours daily.</li>
                                <li>To qualify for rewards, a total of 18 hours of live streaming must be completed weekly (Monday to Sunday).</li>
                                <!-- <li v-if="!hidePeakHourBoxAfterTargetTime">Weekly rewards include <b>100,000 coins</b>, distributed every Monday.</li>
                                <li v-if="!hidePeakHourBoxAfterTargetTime">A minimum of <b>100,000 beans</b> must be earned per week to be eligible for rewards.</li> -->
                            </ul>
                            <!-- <div>
                                <h4 class="mt-4 mb-3">Peak Hour Bonus:</h4>
                                <ul>
                                    <li>Valid streaming hours: <b>9:00 PM - 2:00 AM</b></li>
                                    <li>Hosts must stream and engage in calls for a maximum of 3 hours daily during this time.</li>
                                    <li>To qualify for rewards, a total of 10 hours of live streaming must be completed weekly (Monday to Sunday).</li>
                                    <li>Weekly rewards include <b>50,000 coins</b>, distributed every Monday.</li>
                                </ul>
                            </div> -->
                            <div>
                                <h4 class="mt-4 mb-3">Earn According to Target</h4>    
                                <div class="weekltTarget-ruleTableWrap afterTargetBox">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Target</th>
                                                <th>Reward</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>100K</td>
                                                <td>40K</td>
                                            </tr>
                                            <tr>
                                                <td>250K</td>
                                                <td>75K</td>
                                            </tr>
                                            <tr>
                                                <td>500K</td>
                                                <td>125K</td>
                                            </tr>
                                            <tr>
                                                <td>1M</td>
                                                <td>250K</td>
                                            </tr>
                                            <tr>
                                                <td>2.5M</td>
                                                <td>625K</td>
                                            </tr>
                                            <tr>
                                                <td>5M</td>
                                                <td>1.25M</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <h4 class="mt-4 mb-3">Note :</h4>
                            <ul>
                                <li>For targets <b>up to 500K</b>, Call Earnings + Gifts + Game Tips — <b>all count</b> towards your reward.</li>
                                <li>For <b>1M and above</b>, only <b>Gifts & Game</b> Tips will be counted</li>
                            </ul>
                            <h4 class="mt-4 mb-3">Livestreaming Guidelines</h4>
                            <ul>
                                <li>Ensure your background is tidy and well-organized. Consider using a solid or visually appealing background color for a professional look.</li>
                                <li>Use Bluetooth devices for clear audio quality and a ring light to enhance visual effects and presentation.</li>
                                <li>Dress in smart casual attire to maintain a polished and professional appearance.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
// import downArrow from '../../assets/images/downArrow.png';
import downArrow from '../../assets/images/back-blackArrow.svg';
export default {
    name: 'WeeklyTargetPolicy',
    data() {
        return {
            activeTab: 'language1Tab',
            downArrow: downArrow,

            // hidePeakHourBoxAfterTargetTime: false,
            // showAfterTargetTime: true
        }
    },
    // mounted() {
    //     const targetDate = new Date(2025, 9, 20);
    //     this.hidePeakHourBoxAfterTargetTime = new Date() > targetDate;
    //     this.showAfterTargetTime = new Date() > targetDate;
    //     setInterval(() => {
    //         this.hidePeakHourBoxAfterTargetTime = new Date() > targetDate;
    //         this.showAfterTargetTime = new Date() > targetDate;
    //     }, 1000);
    // },
    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
        },
        handleTabChange(tabId) {
            this.activeTab = tabId;
        },

        //Close Webview on back arrow click
        goBack() {
            this.$router.go(-1);
        }
    }

}
</script>